//
// utils.js
// 
// author: marcio.garcia@newsoftware.com.br
//
export const  cleanSpecial = (s)=> {
    s = s.replace(/[\u0000-\u001f]+/g, "")
         .replace(/[\u0021-\u002F]+/g, "")
         .replace(/[\u003A-\u0040]+/g, "")
         .replace(/[\u005B-\u0060]+/g, "")
         .replace(/[\u007B-\u007F]+/g, "");
    return s;
}

export const  cleanAccent = (s) => {
    s = s.replace(/[\u00e1\u00e0\u00e2\u00e3\u00e4]+/g, "a")
         .replace(/[\u00c1\u00c0\u00c2\u00c3\u00c4]+/g, "A")
         .replace(/[\u00e9\u00e8\u00ea\u00ea]+/g, "e")
         .replace(/[\u00c9\u00c8\u00ca\u00cb]+/g, "E")
         .replace(/[\u00ed\u00ec\u00ee\u00ef]+/g, "i")
         .replace(/[\u00cd\u00cc\u00ce\u00cf]+/g, "I")
         .replace(/[\u00f3\u00f2\u00f4\u00f5\u00f6]+/g, "o")
         .replace(/[\u00d3\u00d2\u00d4\u00d5\u00d6]+/g, "O")
         .replace(/[\u00fa\u00f9\u00fb\u00fc]+/g, "u")
         .replace(/[\u00da\u00d9\u00db]+/g, "U")
         .replace(/[\u00e7]+/g, "c")
         .replace(/[\u00c7]+/g, "C")
         .replace(/[\u00f1]+/g, "n")
         .replace(/[\u00d1]+/g, "N")
    return s;
}